import React, { useState } from 'react';
import { usePreferencesStore } from '../../store/preferencesStore';
import chatService from '../../services/chatService';
import { Toggle, Row, Section } from '../settingsPrimitives';

/* ── Chat tab ────────────────────────────────────────────────────────────────── */
export const ChatTab = ({ t }) => {
  const linkPreviews = usePreferencesStore((s) => s.linkPreviews);
  const readReceipts = usePreferencesStore((s) => s.readReceipts);
  const update       = usePreferencesStore((s) => s.updatePreference);
  const [receiptsError, setReceiptsError] = useState(null);

  // Server-enforced: mirror the toggle to the backend, and revert the local
  // pref if the PUT fails so the UI doesn't misreport the effective state.
  const handleReadReceipts = async (v) => {
    setReceiptsError(null);
    update('readReceipts', v);
    try {
      await chatService.updateChatPreferences({ readReceipts: v });
    } catch (err) {
      update('readReceipts', !v);
      setReceiptsError(err.message || 'Could not update read receipts. Please try again.');
    }
  };

  return (
    <Section title={t('settings.chat')}>
      <Row label={t('settings.linkPreviews')} desc={t('settings.linkPreviewsDesc')}>
        <Toggle value={linkPreviews} onChange={(v) => update('linkPreviews', v)} />
      </Row>
      <Row label={t('settings.readReceipts')} desc={t('settings.readReceiptsDesc')}>
        <Toggle value={readReceipts} onChange={handleReadReceipts} />
      </Row>
      {receiptsError && (
        <div className="privacy-feedback privacy-feedback--error" style={{ marginTop: 6 }}>{receiptsError}</div>
      )}
    </Section>
  );
};
